import { useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'

import QuotasDrawer from '@/pages/components/common/quotas/'
import { getQuotas } from '@/store/gigiChat/Quotas'

const DisplayQuota = () => {
    const { location } = useRouterState()

    useEffect(() => {
        void getQuotas()
    }, [location])

    return (
        <>
            <QuotasDrawer />
        </>
    )
}

export default DisplayQuota
